import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InspectionListPageComponent } from '../pages/list.component';
import { InspectionDetailPageComponent } from '../pages/detail.component';
import { InspectionReportPdfListPageComponent } from '../pages/report-pdf-list.component';
import { InspectionViewPageComponent } from '../pages/view.component';
import { InspectionValidationPageComponent } from '../pages/validation.component';
import { InspectionCollaboratePageComponent } from '../pages/collaborate.component';
import { MachineSelectorPageComponent } from '../pages/machineSelector.component';
import { NewInspectionModelPageComponent } from '../pages/newFromModel.component';
import { environment } from '../../../environments/environment';
import { CurrencyResolver } from '../../utils/currency.resolver';
import { ReportPdfSharePageComponent } from '../../shared/pages/report-list/report-pdf-share.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { CurrentUserResolver } from '../../utils/currentPerson.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { InspectionRestoreListPageComponent } from '../pages/restore-list.component';
import { ChildrenInspectionListPageComponent } from '../pages/children-list.component';
import { ManagerInspectionListPageComponent } from '../pages/admin-list.component';
import { InspectionStatusPageComponent } from '../pages/status.component';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { currentPerson: CurrentUserResolver },
    children: [
      {
        path: appRoute + '/inspections/all',
        component: ManagerInspectionListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/inspections/:inspectionId/status',
        component: InspectionStatusPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/inspections/:inspectionId/view/:returnUrl',
        resolve: { currencies: CurrencyResolver },
        component: InspectionViewPageComponent
      },
      {
        path: appRoute + '/templates/:inspectionId/view/:returnUrl',
        resolve: { currencies: CurrencyResolver },
        component: InspectionViewPageComponent
      },
      {
        path: appRoute + '/inspections/:inspectionId/validations/:returnUrl',
        component: InspectionValidationPageComponent
      }
    ]
  },
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [
      { path: appRoute + '/inspections', component: InspectionListPageComponent },
      { path: appRoute + '/inspections/selectMachine', component: MachineSelectorPageComponent },
      { path: appRoute + '/inspections/selectMachine/:productLineId/:machineId/:serialNumber', component: MachineSelectorPageComponent },
      {
        path: appRoute + '/inspections/selectMachine/:inspectionId/:applicationSubType',
        component: MachineSelectorPageComponent
      },
      {
        path: appRoute + '/inspections/:inspectionId/:applicationSubType/fromModel/:productLineId/:categoryId/:machineId/:serialNumber',
        component: NewInspectionModelPageComponent
      },
      {
        path: appRoute + '/inspections/fromModel/:productLineId/:categoryId/:machineId/:inspectionName/:serialNumber',
        component: NewInspectionModelPageComponent
      },
      { path: appRoute + '/inspections/fromModel/:productLineId/:inspectionName/:serialNumber', component: NewInspectionModelPageComponent },
      { path: appRoute + '/inspections/:itemId/shares', component: ReportPdfSharePageComponent },
      { path: appRoute + '/inspections/:inspectionId', component: InspectionDetailPageComponent },
      { path: appRoute + '/inspections/:inspectionId/inspections', component: ChildrenInspectionListPageComponent },
      {
        path: appRoute + '/inspections/:inspectionId/view',
        resolve: { currencies: CurrencyResolver },
        component: InspectionViewPageComponent
      },
      {
        path: appRoute + '/inspections/:inspectionId/validations',
        component: InspectionValidationPageComponent
      },
      { path: appRoute + '/inspections/:itemId/reports', component: InspectionReportPdfListPageComponent },
      { path: appRoute + '/inspections/:itemId/reports/:reportId/share', component: ReportPdfSharePageComponent },
      { path: appRoute + '/inspections/:inspectionId/restore', component: InspectionRestoreListPageComponent }
      // { path: `${appRoute}/inspections/:inspectionId/collaborate`, component: InspectionCollaboratePageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InspectionsRoutingModule {}

export const routedComponents = [
  InspectionDetailPageComponent,
  InspectionViewPageComponent,
  MachineSelectorPageComponent,
  InspectionCollaboratePageComponent,
  NewInspectionModelPageComponent,
  ReportPdfSharePageComponent,
  InspectionRestoreListPageComponent,
  ChildrenInspectionListPageComponent
];
